/**
 * Upload types preselected as required when inviting a buyer. A sale config
 * can make them depend on the sale via `getDefaultUploadTypes(offerData)`.
 */
export function getDefaultUploadTypes(config, offerData = {}) {
  if (typeof config.getDefaultUploadTypes === 'function')
    return config.getDefaultUploadTypes(offerData || {});
  return config.defaultUploadTypes || [];
}



// WEBPACK FOOTER //
// ./src/app/helpers/uploadTypes.js